/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { OfferNote } from 'types/entities/OfferNote'

interface OfferBackOfficeNotesListProps {
    notes: OfferNote[]
    renderNote: (note: OfferNote) => React.ReactNode
}

const OfferBackOfficeNotesList = (props: OfferBackOfficeNotesListProps) => {
    if (!props.notes.length) {
        return null
    }

    return (
        <div className="OfferBackOfficeNotesList flex flex-col gap-1">
            {props.notes.map((note) => props.renderNote(note))}
        </div>
    )
}

export default OfferBackOfficeNotesList
